import React from 'react';

import Layout from 'layouts/Layout';
import MessagePage from './MessagePage';

const MessagePageLayout = () => <Layout component={MessagePage} />;

export default MessagePageLayout;
